/*LIBRARY*/
import { useEffect, useRef } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import MAP_EDITOR from "../../Components/editor_map/MAP_EDITOR";
import NO_LICENSE_HANDLE from "../../Components/blocked_page/NO_LICENSE_HANDLE";
import COLLAB_BLOCK_VIEWER from "../../Components/blocked_page/COLLAB_BLOCK_VIEWER";
import COLLAB_BLOCK_EDITOR from "../../Components/blocked_page/COLLAB_BLOCK_EDITOR";

/*REDUX*/
import {
  clearProject,
  get_project_only,
} from "../../App/actions/projectActions";
import {
  set_value_properties,
  get_detail_many_layer,
} from "../../App/actions/propertiesActions";
import { finishGenangan } from "../../App/actions/layerNewActions";
import { getDetailLayerById } from "../../App/actions/get_features_action";
import { clearLayer, realtime_update } from "../../App/actions/layerActions";
import { getUserPaymentList } from "../../App/actions/paymentActions";
import { getGroups, getGroupsProject } from "../../App/actions/groupActions";
import { set_value_user } from "../../App/actions/authActions";
import { set_value_layer } from "../../App/actions/layerActions";
import { is_has_license_basic_or_license_sharing } from "../../App/actions/filter_license";
import { get_layer_by_share_link } from "../../App/actions/sharedLinkActions";
import { activities_timeseries } from "../../App/actions/activities";

/*PICTURE*/

/*FUNCTION*/
import decode_params_to_object from "../../App/validation/decode_params_to_object";
import getStatusMember from "../../App/validation/get-status-member";

/*DATA*/
import dict from "../../Data/dict.json";


/*CONST*/
const sidebar_closed = 70;
const mode_page = "viewer";

const PARENT_MAP_EDITOR = ({
  match,
  auth,
  project,
  layer,
  properties,
  loading_reducer,
  getUserPaymentList,
  clearLayer,
  getGroups,
  getGroupsProject,
  finishGenangan,
  clearProject,
  getDetailLayerById,
  set_value_properties,
  get_detail_many_layer,
  get_project_only,
  set_value_layer,
  is_has_license_basic_or_license_sharing,
  get_layer_by_share_link,
  activities_timeseries,
}) => {
  const language = localStorage?.language || "ina";
  const geo_project_link = match?.params?.geo_project_link;
  const { is_mobile, still_loading_layer, still_loading_many_layer } =
    properties;

  useEffect(() => {
    activities_timeseries("view");
  }, [activities_timeseries]);

  useEffect(() => {
    if (is_mobile) {
      set_value_properties({
        key: "is_mobile_close",
        value: true,
      });
      set_value_properties({
        key: "sidebar_height",
        value: sidebar_closed,
      });
    }

    set_value_properties({
      key: "mode_map",
      value: mode_page,
    });
    set_value_layer({
      key: "page_layer_mode",
      value: mode_page,
    });
    set_value_properties({
      key: "sidebar_right_status",
      value: true,
    });

    if (geo_project_link === "share") {
      const search = window?.location?.search?.substring(1);
      let object_param = {};
      let share_link;
      if (search) {
        object_param = JSON.parse(
          '{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}',
          function (key, value) {
            return key === "" ? value : decodeURIComponent(value);
          }
        );
        share_link = object_param?.link;
        get_layer_by_share_link({ link: share_link });
      }
    } else {
      set_value_properties({
        key: "geo_project_link",
        value: geo_project_link,
      });
      get_project_only(geo_project_link);

      getGroupsProject(geo_project_link);
      set_value_properties({
        key: "folder_list_active",
        value: [],
      });
      getUserPaymentList();
      getGroups();
    }
  }, [
    geo_project_link,
    set_value_properties,
    set_value_layer,
    get_project_only,
    getGroupsProject,
    getUserPaymentList,
    getGroups,
    is_mobile,
    get_layer_by_share_link,
  ]);

  useEffect(() => {
    return () => {
      clearLayer();
      clearProject();
      finishGenangan();
      set_value_layer({
        key: "tableStatus",
        value: false,
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const prevGetLayerListStatusRef = useRef();

  useEffect(() => {
    const currentStatus = properties.get_layer_list_status;
    const prevStatus = prevGetLayerListStatusRef.current;

    if (currentStatus === "done" && prevStatus !== currentStatus) {
      const { geo_project } = project;
      const { geo_layer_list } = layer;
      let layer_list_load_first = geo_project?.layer_list_load_first || [];
      layer_list_load_first = layer_list_load_first.filter((item) => !!item);

      const params = window?.location?.search?.substring(1);

      let object_params = {};
      let layer_id;
      let sidebar_right_status = false;

      if (params) {
        object_params = decode_params_to_object(params);
        layer_id = object_params?.layer_id;
        sidebar_right_status =
          object_params?.sidebar_right_status === "true" ? true : false;
      }

      if (layer_id) {
        const folder_id = geo_layer_list.find(
          (item) => item.geo_layer._id === layer_id
        )?.folder;
        const layer = geo_layer_list.find(
          (item) => item.geo_layer._id === layer_id
        )?.geo_layer;
        const features = layer?.geojson?.features || [];
        if (!features?.length && !still_loading_layer) {
          const body = {
            geo_layer_id: layer_id,
            geo_project_id: geo_project._id,
            flyStatus: true,
            folder_id,
          };
          getDetailLayerById(body);
        }
      }

      if (layer_list_load_first.length > 0 && !still_loading_many_layer) {
        const params = {
          layer_list: layer_list_load_first,
          geo_project_id: geo_project._id,
          folder_id: "",
        };
        get_detail_many_layer(params);
      }

      if (sidebar_right_status === true) {
        set_value_properties({
          key: "sidebar_right_status",
          value: true,
        });
      }
    }

    prevGetLayerListStatusRef.current = currentStatus;
  }, [
    properties.get_layer_list_status,
    project,
    layer,
    getDetailLayerById,
    set_value_properties,
    get_detail_many_layer,
    still_loading_layer,
    still_loading_many_layer,
  ]);

  const geo_layer_link =
    match?.params?.geo_layer_link !== "no_layer"
      ? match?.params?.geo_layer_link
      : "";
  const mode = match?.params?.mode;
  const { user } = auth;
  const { loadingProcess, itemLoading, chatStatus, realtimeStatus } = layer;
  const { geo_project } = project;
  const { loading_item_array } = loading_reducer;

  let status_user = "guest";
  const groups = geo_project?.groups || [];

  if (
    !!user?._id &&
    !!geo_project?.user?._id &&
    user?._id === geo_project?.user?._id
  ) {
    status_user = "creator";
  } else if (user?._id) {
    status_user = getStatusMember(groups, user?._id);
  }

  let content;

  /*
  Kemungkinan-kemungkinan state:

  //1. Public buka viewer
  //2. Tidak punya lisensi
  //3. Viewer lolos autorisasi
  //4. Editor lolos autorisasi
  //5. Editor tidak lolos autorisasi meskipun punya lisensi
  //6. Viewer tidak lolos autorisasi meskipun punya lisensi
  //7. Logic lain yg belum terpikirkan

  */

  if (
    loading_item_array.includes("get_project_only") ||
    loading_item_array.includes("get_layer_by_share_link")
  ) {
    content = (
      <main className="main_container">
        <section
          className="container background_white outline_shadow_soft"
          style={{ width: "500px", maxWidth: "100%" }}
        >
          <p className="text_bold sub_color">Loading ...</p>
        </section>
      </main>
    );
  } else if (geo_project.isPublic && mode_page === "viewer") {
    //1. Public buka viewer
    content = <MAP_EDITOR geo_layer_link={geo_layer_link} mode={mode} />;
  } else if (!is_has_license_basic_or_license_sharing()) {
    //2. Tidak punya lisensi
    content = <NO_LICENSE_HANDLE />;
  } else if (
    mode_page === "viewer" &&
    ["creator", "admin", "contributor", "viewer"].includes(status_user)
  ) {
    //3. Viewer lolos autorisasi
    content = <MAP_EDITOR geo_layer_link={geo_layer_link} mode={mode} />;
  } else if (
    mode_page === "editor" &&
    ["creator", "admin", "contributor"].includes(status_user)
  ) {
    //4. Editor lolos autorisasi
    content = <MAP_EDITOR geo_layer_link={geo_layer_link} mode={mode} />;
  } else if (
    mode_page === "editor" &&
    ["viewer", "guest"].includes(status_user)
  ) {
    //5. Editor tidak lolos autorisasi meskipun punya lisensi
    content = <COLLAB_BLOCK_EDITOR />;
  } else if (mode_page === "viewer" && ["guest"].includes(status_user)) {
    //6. Viewer tidak lolos autorisasi meskipun punya lisensi
    content = <COLLAB_BLOCK_VIEWER />;
  } else {
    //7. Logic lain yg belum terpikirkan
    content = <COLLAB_BLOCK_VIEWER />;
  }

  let api_status = "";

  geo_project.api_status = api_status;

  let textLoading = "Saving";
  switch (itemLoading) {
    case "createLayer":
      textLoading = dict["Creating layer"][language];
      break;
    case "importLayer":
      textLoading = dict["Importing layer"][language];
      break;
    case "uploadLayer":
      textLoading = dict["Importing layer"][language];
      break;
    case "edit_general":
      textLoading = dict["Saving changes"][language];
      break;
    case "editAllFields":
      textLoading = dict["Saving changes"][language];
      break;
    case "editLayerForm":
      textLoading = dict["Saving changes"][language];
      break;
    case "pushFeature":
      textLoading = dict["Adding feature"][language];
      break;
    case "push_project_attach":
      textLoading = dict["Attaching layer"][language];
      break;
    case "delete_project_attach":
      textLoading = dict["Deleting attached layer"][language];
      break;
    case "edit_geometry":
      textLoading = dict["Saving geometry changes"][language];
      break;
    case "edit_properties":
      textLoading = dict["Saving attribute value"][language];
      break;
    case "delete_feature":
      textLoading = dict["Deleting"][language];
      break;
    case "hide_feature":
      textLoading = dict["Hiding feature"][language];
      break;
    case "push_field":
      textLoading = dict["Adding column"][language];
      break;
    case "editField":
      textLoading = dict["Saving column"][language];
      break;
    case "deleteField":
      textLoading = dict["Deleting column"][language];
      break;
    case "delete_layer":
      textLoading = dict["Deleting layer"][language];
      break;
    case "get_detail":
      textLoading = dict["Getting GIS data"][language];
      break;
    case "genangan":
      textLoading = dict["Running the inundation algorithm"][language];
      break;
    case "deleteFieldForm":
      textLoading = dict["Deleting table columns"][language];
      break;
    case "move_layers_into_any_folder":
      textLoading = dict["Moving layers"][language];
      break;
    case "delete_layers_bulk":
      textLoading = dict["Deleting layers"][language];
      break;
    default:
      textLoading = itemLoading;
      break;
  }

  return (
    <div>
      {!!textLoading && !chatStatus && !realtimeStatus && loadingProcess && (
        <div
          style={{
            zIndex: "20",
            backgroundColor: "#244aa1",
            color: "#fff",
            position: "fixed",
            top: "0px",
            right: "0px",
            width: "100vw",
            textAlign: "center",
            paddingTop: "10px",
            paddingBottom: "10px",
            fontSize: "17px",
            fontWeight: "500",
          }}
        >
          {textLoading}
        </div>
      )}
      {content}
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  payment: state.payment,
  project: state.project,
  layer: state.layer,
  properties: state.properties,
  license_reducer: state.license_reducer,
  loading_reducer: state.loading_reducer,
});

export default connect(mapStateToProps, {
  getUserPaymentList,
  clearLayer,
  getGroups,
  getGroupsProject,
  finishGenangan,
  clearProject,
  set_value_user,
  getDetailLayerById,
  realtime_update,
  set_value_properties,
  get_detail_many_layer,
  get_project_only,
  set_value_layer,
  is_has_license_basic_or_license_sharing,
  get_layer_by_share_link,
  activities_timeseries,
})(PARENT_MAP_EDITOR);
